<div #datepicker>
    <mat-calendar class="app-datepicker animated-content" [ngClass]="{'active': active, 'app-datepicker-rel': relative}"
        [minDate]="minDate" [maxDate]="maxDate" [selected]="date" (selectedChange)="onDateChange($event)"
        [headerComponent]="calendarHeader">
    </mat-calendar>
    <div class="app-datepicker-overlay" *ngIf="active" (click)="close()"></div>
</div>
